var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon32(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 304,
    viewBox: "0 0 354 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_2717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9.85324 249.489C13.6698 230.663 39.5789 201.306 72.769 205.237C85.5681 206.753 95.5385 221.363 106.101 228.12C115.18 233.928 122.422 237.691 133.545 234.364C173.241 222.493 188.711 173.58 227.629 159.23C232.163 157.558 240.911 154.131 245.727 157.131C253.937 162.245 261.579 169.128 269.25 175.001C278.684 182.224 287.881 189.814 297.794 196.386C301.035 198.536 308.518 204.813 312.834 201.549C319.676 196.376 339.98 115.182 345.524 108.847C357.565 95.0865 370.261 82.1816 385.061 71.3587C395.331 63.8482 405.977 59.4397 417.501 54.534",
    stroke: "#A8EF12",
    strokeWidth: 38,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_2717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 353,
    height: 304,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32);
export default __webpack_public_path__ + "static/media/icon32.f6744d83b8aa8b80ff55a1bc561e9f0b.svg";
export { ForwardRef as ReactComponent };